import AppStoreBadges from 'elements/AppStoreBadges';

export default function AppDownloadPublic() {
    return (
        <div className='w-full flex-1 flex bg-cover bg-center bg-no-repeat' style={{ backgroundImage: 'url(/assets/images/background/app-letoltes.png)' }}>
            <div className='w-full flex-1 flex items-center justify-center bg-black/30 p-4 font-display md:p-8'>
                <div className='flex max-w-5xl flex-col items-center gap-8 text-center'>
                    <h1 className='font-display text-5xl font-black text-gray-50 md:text-8xl'>FürgeDiák App</h1>
                    <p className='max-w-3xl text-sm text-gray-200 md:text-2xl'>Töltsd le a FürgeDiák alkalmazását, és értesülj a legtrendibb módon új munkalehetőségeinkről!</p>
                    <AppStoreBadges className='justify-center' />
                </div>
            </div>
        </div>
    );
}
